/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, no-prototype-builtins */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import moment from 'moment';
import { uniq } from '@linc-technologies/linced-common/utils/arrays';

export default class ClassCountsController extends Controller {
  date = moment().format('YYYY-MM-DD');

  @computed('model.genderField.options.[]')
  get genderOptions() {
    let fieldOptions = this.get('model.genderField.options') || [];
    return fieldOptions.reduce(
      (options, option) => {
        if (['M', 'F'].includes(option.value)) {
          // Skip M/F - custom labels in initial value (below).
          return options;
        }
        options.push({ value: option.value, label: option.label });
        return options;
      },
      [
        { value: 'M', label: 'Boys' },
        { value: 'F', label: 'Girls' },
      ],
    );
  }

  @computed('model.homerooms.[]', 'sortProp', 'sortDir')
  get homerooms() {
    let rows = [];

    this.model.homerooms.forEach((homeroom) => {
      let counts = homeroom.currentLearners.reduce(
        (acc, learner) => {
          let gender = learner.person.gender;

          if (acc.genders.hasOwnProperty(gender)) {
            acc['genders'][gender]++;
          } else {
            acc['genders'][gender] = 1;
          }

          let ethnicity = learner.person.displayEthnicity;

          if (acc.ethnicities.hasOwnProperty(ethnicity)) {
            acc['ethnicities'][ethnicity]++;
          } else {
            acc['ethnicities'][ethnicity] = 1;
          }

          return acc;
        },
        {
          name: homeroom.name,
          total: homeroom.currentLearners.length,
          genders: {},
          ethnicities: {},
        },
      );

      rows.push(counts);
    });

    return rows;
  }

  @computed('homerooms')
  get totals() {
    let counts = this.homerooms.reduce(
      (acc, room) => {
        Object.entries(room.ethnicities).forEach((entry) => {
          let [ethnicity, count] = entry;

          if (acc.ethnicities.hasOwnProperty(ethnicity)) {
            acc['ethnicities'][ethnicity] += count;
          } else {
            acc['ethnicities'][ethnicity] = count;
          }
        });

        Object.entries(room.genders).forEach((entry) => {
          let [gender, count] = entry;

          if (acc.genders.hasOwnProperty(gender)) {
            acc['genders'][gender] += count;
          } else {
            acc['genders'][gender] = count;
          }
        });

        return acc;
      },
      {
        genders: {},
        ethnicities: {},
      },
    );

    counts.total = this.homerooms.reduce((acc, room) => acc + room.total, 0);

    return counts;
  }

  @computed('totals')
  get ethnicities() {
    return uniq(Object.keys(this.totals.ethnicities)).sort();
  }
}
